import { render, staticRenderFns } from "./WorkPlanShiftsAdd.vue?vue&type=template&id=51a6e0a5&scoped=true&"
import script from "./WorkPlanShiftsAdd.vue?vue&type=script&lang=js&"
export * from "./WorkPlanShiftsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a6e0a5",
  null
  
)

export default component.exports